import styled from 'styled-components'
import { GRAYSCALE_50, GRAYSCALE_BORDER } from '../../styles/colors'

interface ContainerProps {
  $width?: number
  $height?: number
  $padding?: number
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${GRAYSCALE_50};
  padding: ${props => props.$padding !== undefined ? `${props.$padding}px` : '8px'};
  border-radius: 6px;
  border: 1px solid ${GRAYSCALE_BORDER};
  width: ${props => props.$width !== undefined ? `${props.$width}px` : '54px'};
  height: ${props => props.$height !== undefined ? `${props.$height}px` : '54px'};
`

interface ImageProps {
  $width?: number
  $height?: number
}

export const Image = styled.img<ImageProps>`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  ${props => props.$width !== undefined && `width: ${props.$width}px;`}
  ${props => props.$height !== undefined && `height: ${props.$height}px;`}
`
